import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  ListQueryParams,
  TrainersListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const TRAINERS_LIST_QUERY_KEY = 'trainers_list';

export const useTrainersListQuery = (
  url: string,
  queryParams: ListQueryParams,
) =>
  useQuery({
    queryKey: [TRAINERS_LIST_QUERY_KEY, url, queryParams],
    queryFn: () =>
      HttpClient.request<TrainersListResponseData>({
        method: 'GET',
        url,
        params: queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
